import { render, staticRenderFns } from "./ItemSearch.vue?vue&type=template&id=010b1df7&"
import script from "./ItemSearch.vue?vue&type=script&lang=js&"
export * from "./ItemSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/82/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010b1df7')) {
      api.createRecord('010b1df7', component.options)
    } else {
      api.reload('010b1df7', component.options)
    }
    module.hot.accept("./ItemSearch.vue?vue&type=template&id=010b1df7&", function () {
      api.rerender('010b1df7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/itemList/ItemSearch.vue"
export default component.exports